import { createSelector } from '@ngrx/store';

import { onlineMenuProductsImagesState } from '../root';

export const isDownloadingAnyOnlineMenuPageImages = createSelector(onlineMenuProductsImagesState, (onlineMenuPagesImages) =>
    onlineMenuPagesImages.some((obj) => obj.isDownloading === true),
);
